module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "green-btn",
    class: {
      disabled_btn: !_vm.allReporting || _vm.allReporting.length === 0
    },
    attrs: {
      "disabled": !_vm.allReporting || _vm.allReporting.length === 0
    },
    on: {
      "click": _vm.excel
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Téléchargez\n\t\t\t")])])]), _vm._v(" "), _c('v-dialog'), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "modal-share",
      "classes": ['v--modal', 'modal-success'],
      "pivot-y": 0.2,
      "width": 300,
      "height": 195
    }
  }, [_c('div', {
    staticClass: "confirm-modal-content"
  }, [_c('div', {
    staticClass: "modal-title"
  }, [_c('h6', [_vm._v("Partager cette entrée avec")])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-content"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user_id_notification),
      expression: "user_id_notification"
    }],
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.user_id_notification = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.allUtilisateurs), function(data) {
    return _c('option', {
      domProps: {
        "value": data.user.id
      }
    }, [_vm._v(_vm._s(data.user.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-buttons"
  }, [_c('button', {
    on: {
      "click": _vm.share
    }
  }, [_vm._v("Confirmer")])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "modal-confirm",
      "classes": ['v--modal', 'modal-confirm'],
      "pivot-y": 0.2,
      "width": 400,
      "height": 125
    }
  }, [_c('div', {
    staticClass: "confirm-modal-content"
  }, [_c('div', {
    staticClass: "modal-title"
  }, [_c('h6', [_vm._v("Voulez-vous supprimer cette ligne ?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-button"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.$modal.hide('modal-confirm')
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.destroy
    }
  }, [_vm._v("Confirmer")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row main-wrap"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "onglet"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client),
      expression: "client"
    }],
    attrs: {
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.client = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.reporting]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Client")]), _vm._v(" "), (_vm.current_user_role === 'admin' || _vm.current_user_role == 'Consultant') ? [_c('option', {
    staticClass: "row clients-assignes-content",
    domProps: {
      "value": _vm.all_clients
    }
  }, [_vm._v("\n              Tous les clients\n            ")])] : _vm._e(), _vm._v(" "), _vm._l((_vm.allClients), function(client) {
    return [(_vm.current_user_role === 'admin') ? [_c('option', {
      staticClass: "row clients-assignes-content",
      domProps: {
        "value": client.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(client.user.name) + "\n\t\t\t\t\t\t\t")])] : [_vm._l((client.utilisateur), function(utilisateur_assigne) {
      return [(_vm.utilisateur == utilisateur_assigne.iduser) ? _c('option', {
        staticClass: "row clients-assignes-content",
        domProps: {
          "value": client.id
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(client.user.name) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e()]
    })]]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "section-bg"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": _vm.submitForm
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('hr', {
    staticClass: "hr-text",
    attrs: {
      "data-content": "Général"
    }
  }), _vm._v(" "), (_vm.updating && _vm.current_user_role != 'admin') ? _c('div', {
    staticClass: "row"
  }, [_vm._m(1)]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "nom"
    }
  }, [_vm._v("Nom")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.utilisateur),
      expression: "utilisateur"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.utilisateur = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.allUtilisateurs), function(data) {
    return (_vm.current_user_id == data.user.id || _vm.current_user_role == 'admin') ? _c('option', {
      domProps: {
        "value": data.user.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(data.user.name) + "\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "client"
    }
  }, [_vm._v("Client")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client),
      expression: "client"
    }],
    attrs: {
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.client = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.reporting]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Choisissez un client")]), _vm._v(" "), (_vm.current_user_role == 'admin' || _vm.current_user_role == 'Consultant') ? [_c('option', {
    staticClass: "row clients-assignes-content",
    domProps: {
      "value": _vm.all_clients
    }
  }, [_vm._v("\n                        Tous les clients\n                      ")])] : _vm._e(), _vm._v(" "), _vm._l((_vm.allClients), function(client) {
    return [(_vm.current_user_role == 'admin' || _vm.current_user_role == 'Consultant') ? [_c('option', {
      staticClass: "row clients-assignes-content",
      domProps: {
        "value": client.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(client.user.name) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")])] : [_vm._l((client.utilisateur), function(utilisateur_assigne) {
      return [(_vm.utilisateur == utilisateur_assigne.iduser) ? _c('option', {
        staticClass: "row clients-assignes-content",
        domProps: {
          "value": client.id
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(client.user.name) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]
    })]]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "entite"
    }
  }, [_vm._v("Entité")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entite),
      expression: "entite"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.entite = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Choisissez une entité")]), _vm._v(" "), _vm._l((_vm.allEntite), function(data) {
    return (data && data.idclient == _vm.client) ? _c('option', {
      domProps: {
        "value": data.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(data.name) + "\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "dateStart"
    }
  }, [_vm._v("Période")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "min": "2015-01-01",
      "range": ""
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "temps"
    }
  }, [_vm._v("Temps")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.heures),
      expression: "heures"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "max": "99",
      "min": "0",
      "id": "heure",
      "placeholder": "Heures"
    },
    domProps: {
      "value": (_vm.heures)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.heures = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.min),
      expression: "min"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.min = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.minutes), function(minute) {
    return _c('option', [_vm._v(_vm._s(minute.text))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox col-sm-4"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hatvp),
      expression: "hatvp"
    }],
    attrs: {
      "id": "check",
      "type": "checkbox",
      "name": "check",
      "value": "check"
    },
    domProps: {
      "checked": Array.isArray(_vm.hatvp) ? _vm._i(_vm.hatvp, "check") > -1 : (_vm.hatvp)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.hatvp,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "check",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.hatvp = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.hatvp = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.hatvp = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "check"
    }
  }, [_vm._v("Inclusion HATVP")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('hr', {
    staticClass: "hr-text",
    attrs: {
      "data-content": "Action"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "catergorie"
    }
  }, [_vm._v("Catégorie")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.action_categorie),
      expression: "action_categorie"
    }],
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.action_categorie = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.all_actions_categories), function(action_categorie) {
    return _c('option', {
      domProps: {
        "value": action_categorie.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(action_categorie.name) + "\n\t\t\t\t\t\t\t\t\t\t")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.action_type),
      expression: "action_type"
    }],
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.action_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.action_categorie === undefined) ? _c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Choisissez une catégorie")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.all_actions_types), function(action_type) {
    return (action_type.idactioncategorie === _vm.action_categorie) ? _c('option', {
      domProps: {
        "value": action_type.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(action_type.name) + "\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "commentaire"
    }
  }, [_vm._v("Commentaire")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.action_commentaire),
      expression: "action_commentaire"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "comentaire",
      "required": ""
    },
    domProps: {
      "value": (_vm.action_commentaire)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.action_commentaire = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.updating != true || (_vm.recurring && _vm.updating == true)) ? [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "checkbox col-sm-12"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recurring),
      expression: "recurring"
    }],
    attrs: {
      "id": "recurring",
      "type": "checkbox",
      "name": "recurring",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.recurring) ? _vm._i(_vm.recurring, "1") > -1 : (_vm.recurring)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.recurring,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.recurring = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.recurring = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.recurring = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "for": "recurring"
    }
  }, [_vm._v("Tâche récurrente")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    style: (_vm.recurring == 1 ? '' : 'opacity: 0.5;pointer-events:none')
  }, [_c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "starts_at"
    }
  }, [_vm._v("Date de début")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "min": "2015-01-01",
      "required": _vm.recurring == 1 ? true : false
    },
    on: {
      "selected": function($event) {
        return _vm.updateRecurringDetails()
      }
    },
    model: {
      value: (_vm.recurring_starts_at),
      callback: function($$v) {
        _vm.recurring_starts_at = $$v
      },
      expression: "recurring_starts_at"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "frequency"
    }
  }, [_vm._v("Répéter tous les")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recurring_frequency),
      expression: "recurring_frequency"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "10",
      "required": _vm.recurring == 1 ? true : false
    },
    domProps: {
      "value": (_vm.recurring_frequency)
    },
    on: {
      "change": function($event) {
        return _vm.updateRecurringDetails()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.recurring_frequency = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recurring_unit),
      expression: "recurring_unit"
    }],
    attrs: {
      "required": _vm.recurring == 1 ? true : false
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.recurring_unit = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.updateRecurringDetails()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("jours")]), _vm._v(" "), _vm._l((_vm.recurring_units), function(recurring_unit) {
    return _c('option', {
      domProps: {
        "value": recurring_unit.value
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(recurring_unit.name) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "frequency"
    }
  }, [_vm._v("Se produira tous les")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recurring_detail),
      expression: "recurring_detail"
    }],
    attrs: {
      "required": _vm.recurring == 1 ? true : false
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.recurring_detail = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.recurring_details), function(recurring_detail) {
    return _c('option', {
      domProps: {
        "value": recurring_detail.value
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(recurring_detail.name) + "\n\t\t\t\t\t\t\t\t\t\t\t")])
  }), 0)])])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    style: (_vm.hatvp == 1 ? '' : 'opacity: 0.5;pointer-events:none')
  }, [_c('hr', {
    staticClass: "hr-text",
    attrs: {
      "data-content": "HATVP"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "theme"
    }
  }, [_vm._v("Domaine(s) d'intervention *")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.all_domaines_interventions,
      "multiple": true,
      "label": "name",
      "required": _vm.hatvp == 1 ? true : false,
      "track-by": "id"
    },
    model: {
      value: (_vm.domaine_interventions),
      callback: function($$v) {
        _vm.domaine_interventions = $$v
      },
      expression: "domaine_interventions"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "theme"
    }
  }, [_vm._v("Objet / Objectif poursuivi *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.action_theme),
      expression: "action_theme"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "theme",
      "required": _vm.hatvp == 1 ? true : false
    },
    domProps: {
      "value": (_vm.action_theme)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.action_theme = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "catergorie"
    }
  }, [_vm._v("Catégorie de responsable(s) public(s) sollicité(s) *")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.all_decideurs_categories,
      "multiple": true,
      "required": _vm.hatvp == 1 ? true : false,
      "label": "name",
      "track-by": "id"
    },
    model: {
      value: (_vm.decideur_publique_categorie),
      callback: function($$v) {
        _vm.decideur_publique_categorie = $$v
      },
      expression: "decideur_publique_categorie"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', [_vm._v("Fonction du ou des responsable(s) public(s) sollicité(s)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.decideur_publique_fonction),
      expression: "decideur_publique_fonction"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.decideur_publique_fonction)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.decideur_publique_fonction = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "decision"
    }
  }, [_vm._v("Type(s) d’actions conduites *")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.all_action_type_hatvp,
      "multiple": true,
      "required": _vm.hatvp == 1 ? true : false,
      "label": "name",
      "track-by": "id"
    },
    model: {
      value: (_vm.action_type_hatvp),
      callback: function($$v) {
        _vm.action_type_hatvp = $$v
      },
      expression: "action_type_hatvp"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "decision"
    }
  }, [_vm._v("Décision(s) publique(s) concernée(s) *")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.all_decision_publique,
      "multiple": true,
      "label": "name",
      "track-by": "id",
      "required": _vm.hatvp == 1 ? true : false
    },
    model: {
      value: (_vm.decision_publique),
      callback: function($$v) {
        _vm.decision_publique = $$v
      },
      expression: "decision_publique"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "submit-btn"
  }, [(_vm.updating == false) ? _c('button', {
    staticClass: "btn btn-default green-btn"
  }, [_vm._v("Créer une entrée")]) : _vm._e(), _vm._v(" "), (_vm.updating == true) ? _c('button', {
    staticClass: "btn btn-default green-btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Modifier l'entrée")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "filters"
  }, [_c('p', {
    staticClass: "clear",
    on: {
      "click": _vm.clearFilter
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Réinitialiser tous les champs\n\t\t\t\t\t\t")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.user),
      expression: "filters.user"
    }],
    class: {
      active: _vm.filters.user
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "user", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.reporting]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Nom")]), _vm._v(" "), _vm._l((_vm.allUtilisateurs), function(user) {
    return _c('option', {
      domProps: {
        "value": user.id
      }
    }, [_vm._v(_vm._s(user.user.name))])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.entite),
      expression: "filters.entite"
    }],
    class: {
      active: _vm.filters.entite
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "entite", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.reporting]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Entité")]), _vm._v(" "), _vm._l((_vm.allEntite), function(data) {
    return (data.idclient == _vm.client) ? _c('option', {
      domProps: {
        "value": data.id
      }
    }, [_vm._v(_vm._s(data.name))]) : _vm._e()
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.month),
      expression: "filters.month"
    }],
    class: {
      active: _vm.filters.month
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "month", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.reporting]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Mois")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "00"
    }
  }, [_vm._v("Janvier")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "01"
    }
  }, [_vm._v("Février")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "02"
    }
  }, [_vm._v("Mars")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "03"
    }
  }, [_vm._v("Avril")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "04"
    }
  }, [_vm._v("Mai")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "05"
    }
  }, [_vm._v("Juin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "06"
    }
  }, [_vm._v("Juillet")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "07"
    }
  }, [_vm._v("Août")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "08"
    }
  }, [_vm._v("Septembre")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "09"
    }
  }, [_vm._v("Octobre")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Novembre")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("Décembre")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.year),
      expression: "filters.year"
    }],
    class: {
      active: _vm.filters.year
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "year", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.reporting]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Année")]), _vm._v(" "), _vm._l((_vm.filters.years), function(value, index) {
    return _c('option', {
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(value))])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.temps),
      expression: "filters.temps"
    }],
    class: {
      active: _vm.filters.temps
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "temps", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.reporting]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Temps")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Moins de 2h")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Moins de 4h")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("Moins de 6h")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("Moins de 8h")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Plus de 8h")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.action_categorie),
      expression: "filters.action_categorie"
    }],
    class: {
      active: _vm.filters.action_categorie
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "action_categorie", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.reporting]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Catégorie")]), _vm._v(" "), _vm._l((_vm.all_actions_categories), function(data) {
    return _c('option', {
      domProps: {
        "value": data.id
      }
    }, [_vm._v(_vm._s(data.name))])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.action_type),
      expression: "filters.action_type"
    }],
    class: {
      active: _vm.filters.action_type
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "action_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.reporting]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Type")]), _vm._v(" "), _vm._l((_vm.all_actions_types), function(data) {
    return (data.idactioncategorie === _vm.filters.action_categorie || _vm.filters.action_categorie === '') ? _c('option', {
      domProps: {
        "value": data.id
      }
    }, [_vm._v(_vm._s(data.name))]) : _vm._e()
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.decideur_categorie),
      expression: "filters.decideur_categorie"
    }],
    class: {
      active: _vm.filters.decideur_categorie
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filters, "decideur_categorie", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.reporting]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Catégorie du décideur")]), _vm._v(" "), _vm._l((_vm.all_decideurs_categories), function(data) {
    return _c('option', {
      domProps: {
        "value": data.id
      }
    }, [_vm._v(_vm._s(data.name))])
  })], 2)])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-bordered desktop"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.allReporting), function(reporting) {
    return _c('tr', {
      class: _vm.id == reporting.id ? 'warning' : ''
    }, [_c('td', {
      staticClass: "share-reporting",
      on: {
        "click": function($event) {
          return _vm.showShareMenu($event, reporting)
        }
      }
    }, [_vm._v("⋮")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(reporting.client.user.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(reporting.utilisateur.user.name))]), _vm._v(" "), _c('td', [(reporting.entite) ? [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(reporting.entite.name) + "\n\t\t\t\t\t\t\t")] : _vm._e()], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(reporting.dateclean))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(reporting.temps))]), _vm._v(" "), _c('td', [(reporting.action_categorie) ? [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(reporting.action_categorie.name) + "\n\t\t\t\t\t\t\t")] : _vm._e()], 2), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(reporting.action_type.name) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(reporting.action_commentaire))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(reporting.action_theme))]), _vm._v(" "), _c('td', [_vm._l((reporting.domaine_interventions), function(domaine_intervention) {
      return [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(domaine_intervention.name)), _c('br'), _c('br')]
    })], 2), _vm._v(" "), _c('td', [_vm._l((reporting.decideur_publique_categorie), function(decideur_publique_categorie) {
      return [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(decideur_publique_categorie.name)), _c('br'), _c('br')]
    })], 2), _vm._v(" "), _c('td', [_vm._l((reporting.action_h_a_t_v_p_type), function(action_h_a_t_v_p_type) {
      return [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(action_h_a_t_v_p_type.name)), _c('br'), _c('br')]
    })], 2)])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shareMenuVisible == 1),
      expression: "shareMenuVisible == 1"
    }],
    staticClass: "share-wrap"
  }, [_c('div', {
    staticClass: "overlay_shareMenu",
    on: {
      "click": _vm.hideShareMenu
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shareMenu"
  }, [_c('i', {
    staticClass: "fa fa-times-circle fa-2x",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.hideShareMenu
    }
  }), _vm._v(" "), _c('ul', [_c('li', {
    on: {
      "click": _vm.shareNotification
    }
  }, [_vm._v("Partager la ligne")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.fillForUpdate
    }
  }, [_vm._v("Modifier la ligne")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.deleteReporting
    }
  }, [_vm._v("Supprimer la ligne")])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Reporting Global"), _c('i', {
    staticClass: "fa fa-refresh fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 text-danger"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tVous êtes en mode édition de ligne"), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v(" ")]), _vm._v(" "), _c('th', [_vm._v("Client")]), _vm._v(" "), _c('th', [_vm._v("Nom")]), _vm._v(" "), _c('th', [_vm._v("Entité")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Temps")]), _vm._v(" "), _c('th', [_vm._v("Catégorie")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Commentaire Time-sheet")]), _vm._v(" "), _c('th', [_vm._v("Objet/Objectif poursuivi")]), _vm._v(" "), _c('th', [_vm._v("Domaine d'intervention")]), _vm._v(" "), _c('th', [_vm._v("Catégorie de responsable(s) public(s) sollicité(s)")]), _vm._v(" "), _c('th', [_vm._v("Type(s) d'actions conduites")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-318e6859","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./assets/components/Reporting.vue
// module id = 199
// module chunks = 0